import { render, staticRenderFns } from "./StatsTeam.vue?vue&type=template&id=88e8871a&lang=html&"
import script from "./StatsTeam.vue?vue&type=script&lang=js&"
export * from "./StatsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsTeam.vue"
export default component.exports